import { createCustomElement } from '@angular/elements'
import { createApplication } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

async function main() {
  const appRef = await createApplication(appConfig)
  const injector = appRef.injector

  // Get the router and force initial navigation
  const router = injector.get(Router)
  router.initialNavigation() // Ensure router processes the URL

  const elm = createCustomElement(AppComponent, { injector })
  customElements.define('tcd-root', elm)
}

main().catch((err) => console.error(err))
